export default __webpack_public_path__ + "static/media/7883.f82ffb0b.jpg";